import { api } from './client';

export interface ChecklistItem {
  id: string;
  text: string;
  description: string | null;
  position: number;
  created_at: number;
}

export interface PublicChecklistItem {
  id: string;
  text: string;
  description: string | null;
}

export interface ChecklistInput {
  text: string;
  description?: string | null;
}

export function listChecklist() {
  return api.get<ChecklistItem[]>('/admin/checklist');
}

export function createChecklistItem(input: ChecklistInput) {
  return api.post<ChecklistItem>('/admin/checklist', input);
}

export function updateChecklistItem(id: string, input: ChecklistInput) {
  return api.put<ChecklistItem>(`/admin/checklist/${id}`, input);
}

export function deleteChecklistItem(id: string) {
  return api.delete<{ id: string }>(`/admin/checklist/${id}`);
}

export function reorderChecklist(ids: string[]) {
  return api.post<{ ok: true }>('/admin/checklist/reorder', { ids });
}

// Public — no auth required.
export function getPublicChecklist() {
  return api.get<PublicChecklistItem[]>('/checklist', { skipAuth: true });
}
